class Talkable {
    constructor() {
        this.talkable = window['_talkableq'] || (window['_talkableq'] = []);
    }

    authenticateCustomer(email = '', firstName = '', lastName = '') {
        try {
            let payload = {
                email: email,
                first_name: firstName,
                last_name: lastName,
            };

            this.talkable.push(['authenticate_customer', payload]);
        } catch (error) {
            console.log(error);
        }
    }
}

export default new Talkable();
